import { DATE_T_FORMAT_BE, UI_DATE_FORMAT } from '@/common/constants';
import { subDays } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import {
  redirectToAlarmPage,
  redirectToDataExplorerPage,
  redirectToLogsPage,
} from '@/common/domains';
import { StepProgress } from '@/rtk/settingsActivityTypes';
import { DATE_RANGE_DAY } from '../DataCharts/RangesLogic';

export const INITIAL_PROGRESS_STEPS: StepProgress = {
  activeStep: -1,
  failStep: -1,
  steps: ['Request send', 'Request acknowledged'],
};
export const REQUEST_FAILED_MESSAGE = 'Request failed';
export const REQUEST_FAILED_ADVICE = 'Please try again';
export const SERVER_ERROR_MESSAGE = 'Server error occurred';
export const UPCOMING_DATA_WARNING =
  'Requesting the upload of upcoming data implies that all historical data located in the buffer gets discarded.';

export const getSevenDaysAgoInFarmTime = (date: Date, timeZone: string) =>
  fromZonedTime(subDays(toZonedTime(date, timeZone), 7), timeZone);

export const generateProgressSteps = (
  activeStep?: number,
  failStep?: number,
  sendTime?: string,
  endTime?: string,
  error?: string,
  advice?: string,
) => {
  const firstStepFailed = failStep === 0;
  const secondStepFailed = failStep === 1;

  return {
    activeStep: activeStep ?? INITIAL_PROGRESS_STEPS.activeStep,
    failStep: failStep ?? INITIAL_PROGRESS_STEPS.failStep,
    steps: [
      `${firstStepFailed ? error || REQUEST_FAILED_MESSAGE : 'Request send'}${
        sendTime ? `\n${sendTime}` : ''
      }${firstStepFailed && advice ? `\n${advice}` : ''}`,
      `${
        secondStepFailed
          ? error || REQUEST_FAILED_MESSAGE
          : 'Request acknowledged'
      }${endTime ? `\n${endTime}` : ''}${
        secondStepFailed && advice ? `\n${advice}` : ''
      }`,
    ],
  };
};

export const generateDotMenuOptions = (
  entityId: string,
  fromDate: string,
  toDate: string,
  navigate: (...args) => void,
  toFarmLocalTime: (...args) => void,
  onClose: () => void,
) => [
  {
    title: 'Click to navigate to Data Explorer',
    label: 'Data Explorer',
    onClickFn: (event) => {
      event.stopPropagation();
      redirectToDataExplorerPage(
        navigate,
        entityId,
        toFarmLocalTime(fromDate, UI_DATE_FORMAT),
        DATE_RANGE_DAY,
        '',
        true,
      );

      onClose();
    },
  },
  {
    title: 'Click to navigate to Events',
    label: 'Events',
    onClickFn: (event) => {
      event.stopPropagation();

      redirectToAlarmPage(
        entityId,
        { date: { start: fromDate, end: toDate } },
        navigate,
        false,
      );

      onClose();
    },
  },
  {
    title: 'Click to navigate to Logs',
    label: 'Logs',
    onClickFn: (event) => {
      event.stopPropagation();
      redirectToLogsPage(
        navigate,
        entityId,
        toFarmLocalTime(fromDate, DATE_T_FORMAT_BE),
      );
      onClose();
    },
  },
];
